(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/slides/assets/javascripts/slides.js') >= 0) return;  svs.modules.push('/components/onboarding/slides/assets/javascripts/slides.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useRef = _React.useRef,
  useCallback = _React.useCallback,
  useState = _React.useState,
  useMemo = _React.useMemo,
  useEffect = _React.useEffect,
  Children = _React.Children,
  isValidElement = _React.isValidElement,
  cloneElement = _React.cloneElement;
const _svs$components$onboa = svs.components.onboarding.slides,
  SlideIndicator = _svs$components$onboa.SlideIndicator,
  useBuildAnimations = _svs$components$onboa.useBuildAnimations;

const Slides = _ref => {
  let children = _ref.children,
    classNames = _ref.className,
    onSlideChange = _ref.onSlideChange,
    animations = _ref.animations,
    keepSlides = _ref.keepSlides;
  const _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeSlide = _useState2[0],
    setActiveSlide = _useState2[1];
  const isAnimating = useRef(false);
  const slidesElRef = useRef(new Map());
  const _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    slidesRef = _useState4[0],
    setSlidesRef = _useState4[1];
  const _useBuildAnimations = useBuildAnimations(animations, keepSlides),
    _useBuildAnimations2 = _slicedToArray(_useBuildAnimations, 3),
    resetPositions = _useBuildAnimations2[0],
    slideLeftAsync = _useBuildAnimations2[1],
    slideRightAsync = _useBuildAnimations2[2];
  const _useMemo = useMemo(() => {
      const arrayOfSlides = Children.toArray(children);
      const childs = Children.map(arrayOfSlides, (child, index) => {
        if (isValidElement(child)) {
          return cloneElement(child, {
            ref: ref => {
              slidesElRef.current.set(index, ref);
            }
          });
        }
        return null;
      });
      return [childs, Children.count(childs)];
    }, [children]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    preparedSlides = _useMemo2[0],
    preparedSlidesCount = _useMemo2[1];
  const changeSlide = useCallback(async newSlideIndex => {
    if (newSlideIndex === activeSlide || isAnimating.current) {
      return;
    }
    let arr;
    let animationAsyncFn;
    const shouldAnimateOut = newSlideIndex < activeSlide;
    const shouldAnimateIn = newSlideIndex > activeSlide;
    if (shouldAnimateOut) {
      animationAsyncFn = slideRightAsync;
    } else if (shouldAnimateIn) {
      animationAsyncFn = slideLeftAsync;
    }
    if (keepSlides) {
      const outEl = [];
      const inEl = [];
      slidesElRef.current.forEach((el, index) => {
        if (shouldAnimateIn && index > activeSlide && index <= newSlideIndex) {
          inEl.push(el);
        } else if (shouldAnimateOut && index <= activeSlide && index > newSlideIndex) {
          outEl.push(el);
        }
      });
      outEl.reverse();
      arr = [outEl, inEl];
    } else {
      arr = [[slidesElRef.current.get(activeSlide)], [slidesElRef.current.get(newSlideIndex)]];
    }
    isAnimating.current = true;
    if (onSlideChange) {
      onSlideChange(newSlideIndex);
    }
    await animationAsyncFn(arr);
    setActiveSlide(newSlideIndex);
    isAnimating.current = false;
  }, [activeSlide, onSlideChange, slideLeftAsync, slideRightAsync, keepSlides]);
  const className = ['pg_onboardingslides'];
  if (classNames) {
    className.push(classNames);
  }
  const nextDisalbed = activeSlide >= preparedSlidesCount - 1;
  const prevDisalbed = activeSlide <= 0;
  const nextSlide = useCallback(() => {
    if (!nextDisalbed) {
      changeSlide(activeSlide + 1);
    }
  }, [activeSlide, changeSlide, nextDisalbed]);
  const prevSlide = useCallback(() => {
    if (!prevDisalbed) {
      changeSlide(activeSlide - 1);
    }
  }, [activeSlide, prevDisalbed, changeSlide]);
  useEffect(() => {
    const slideRefEl = slidesRef;
    const slidePreventSizeLeft = 20;
    const slidePreventSizeRight = slidePreventSizeLeft * -1;
    const slideFlipSizeLeft = 60;
    const slideFlipSizeRight = slideFlipSizeLeft * -1;
    let slideStartPos;
    const touchStart = e => {
      slideStartPos = e.touches[0].screenX;
    };
    const touchMove = e => {
      const slideMoveDiff = slideStartPos - e.touches[0].screenX;
      if (slideMoveDiff < slidePreventSizeRight || slideMoveDiff > slidePreventSizeLeft) {
        e.preventDefault();
      }
      if (slideMoveDiff < slideFlipSizeRight) {
        prevSlide();
      } else if (slideMoveDiff > slideFlipSizeLeft) {
        nextSlide();
      }
    };
    if (slideRefEl) {
      slideRefEl.addEventListener('touchstart', touchStart);
      slideRefEl.addEventListener('touchmove', touchMove);
    }
    return () => {
      if (slideRefEl) {
        slideRefEl.removeEventListener('touchstart', touchStart);
        slideRefEl.removeEventListener('touchmove', touchMove);
      }
    };
  }, [nextSlide, prevSlide, slidesRef]);
  useEffect(() => {
    const resetPositionsFn = async () => {
      const arr = Array.from(slidesElRef.current.values());
      await resetPositions(arr);
    };
    resetPositionsFn();
  }, []);
  return React.createElement("div", {
    className: className.join(' '),
    ref: slidesElRef => {
      setSlidesRef(slidesElRef);
    }
  }, preparedSlides, React.createElement(SlideIndicator, {
    activeSlide: activeSlide,
    branding: "inverted",
    isNextDisalbed: nextDisalbed,
    isPrevDisalbed: prevDisalbed,
    nextSlide: nextSlide,
    prevSlide: prevSlide,
    setActiveSlide: changeSlide,
    totalCount: preparedSlidesCount
  }));
};
setGlobal('svs.components.onboarding.slides.Slides', Slides);

 })(window);